import { useCallback } from "react";

import {
  useDealActions,
  // useDealActions,
  useDealIdSelector
} from "store";
import { INotification, UrlQueryParams } from "store/types";
import { JSON_to_URLEncoded } from "utils";

import { useNavigate } from "..";
import { NotificationHandlerType } from "./use-click-handler";

export function useFolderHook(): NotificationHandlerType {
  const navigate = useNavigate();
  const currentDealId: number | undefined = useDealIdSelector();
  // const { getDealAndStoreAction } = useDealActions();
  const { getFilesAction, getFoldersAction } = useDealActions();

  return useCallback(
    async ({ components, read_at }: INotification) => {
      const searchObj: UrlQueryParams = {};

      // if (currentDealId == components.deal_id) {
      //   await getDealAndStoreAction(components.deal_id);
      // }
      if (components.type === "deleted") {
        navigate({
          route: "dealWorkspace",
          params: { deal_id: components.deal_id }
        });
      }

      if (components.type === "shared") {
        searchObj.section = components.target_section_id;
        navigate({
          route: "dealFolder",
          params: { deal_id: components.deal_id, folder_id: components.target_section_id },
          search: JSON_to_URLEncoded(searchObj)
        });
      }

      if (components.type === "new" && components.section_id) {
        searchObj.section = components.section_id;
        navigate({
          route: "dealFolder",
          params: { deal_id: components.deal_id, folder_id: components.target_section_id },
          search: JSON_to_URLEncoded(searchObj)
        });
      }

      if (components.type === "uploaded" && components.section_id) {
        searchObj.section = components.section_id;

        // Refetch data before redirect if notification was unread
        if (currentDealId === components.deal_id && !read_at) {
          await Promise.allSettled([
            getFilesAction(components.deal_id),
            getFoldersAction({ dealId: components.deal_id })
          ]);
        }

        navigate({
          route: "dealFolder",
          params: { deal_id: components.deal_id, folder_id: components.section_id },
          search: JSON_to_URLEncoded(searchObj)
        });
      }
    },
    [currentDealId]
  );
}
